import { useEffect, useRef } from 'react';
import { env } from '@pass-frontend/features/configuration/util';
import { trace } from '@pass-frontend/utility/swiss-knife';
import { useCurrentUserData } from './use-current-user-data';

const { PASS_UI__GOVERNMENT_BASE_URL, PASS_UI__ARCADE_WEB_BASE_URL } = env();

export function useProductExperienceGuard() {
  const { loading, currentSponsor, isRenewActive, isImpersonatedView } =
    useCurrentUserData();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (loading || hasRedirected.current) return;
    if (!currentSponsor?.product) return;
    if (isImpersonatedView) return;

    const product = currentSponsor.product;
    const isOnePassProduct = product === 'onePass';
    const isRenewActiveProduct = product === 'renewActive';

    trace(
      `product-experience-guard: sponsorProduct=${product}, isRenewActive=${isRenewActive}`,
    );

    let redirectUrl: string | null = null;

    if (isRenewActive && isOnePassProduct) {
      redirectUrl = `${PASS_UI__GOVERNMENT_BASE_URL}`;
    } else if (!isRenewActive && isRenewActiveProduct) {
      redirectUrl = `${
        PASS_UI__ARCADE_WEB_BASE_URL || 'https://member.uhc.com'
      }`;
    }

    if (redirectUrl) {
      trace(
        `product-experience-guard: mismatch detected, redirecting to ${redirectUrl}`,
      );
      hasRedirected.current = true;
      window.location.href = redirectUrl;
    }
  }, [loading, currentSponsor?.product, isRenewActive, isImpersonatedView]);
}
